import { FETCH_PRODUCTS_BY_REF } from '@/redux/actions/products.actions'
import { ADD_PRODUCT_BY_REF } from '@/redux/actions/project.actions'

const initialState = {
	searchByRef: {
		loading: false,
		matchingTerm: null,
		coincidences: []
	}
}

const searchByRef = (state = initialState.searchByRef, action) => {
	switch (action.type) {
		case FETCH_PRODUCTS_BY_REF.REQUEST:
			return {
				matchingTerm: action.payload.matchingTerm,
				coincidences: [],
				loading: true
			}
		case FETCH_PRODUCTS_BY_REF.SUCCESS:
			return {
				matchingTerm: action.payload.matchingTerm,
				coincidences: action.payload.coincidences,
				loading: false
			}
		case FETCH_PRODUCTS_BY_REF.FAILURE:
		case ADD_PRODUCT_BY_REF.SUCCESS:
			return {
				matchingTerm: null,
				coincidences: [],
				loading: false
			}
		default:
			return state
	}
}

export default {
	name: 'products',
	reducers: {
		searchByRef
	}
}
